<template>
    <div class="" :class="{ 'md:grid md:gap-6 md:grid-cols-2': withColumns }">
        <div class="" v-for="phone in phones" :key="phone.tel">
            <div class="mt-1 flex space-x-1">
                <a :href="`tel:${phone.tel}`">
                    <svg
                        class="w-4 h-4 text-indigo-500 inline-block"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                        ></path>
                    </svg>
                    {{ phone.number }}
                </a>
                <label class="block text-sm font-medium leading-5 text-gray-700" v-if="phone.label">
                    ({{ phone.label }})
                </label>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PhonesList',
    props: {
        phones: Array,
        withColumns: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
};
</script>
